// External Imports
import get from 'lodash/fp/get';
import { createSelector } from 'reselect';

// Internal Imports
import { getMatch } from './getMatch.js';

// Local Functions
const getLocale = createSelector(
  getMatch,
  (pathMatch) => get('query.locale', pathMatch) || get('params.language', pathMatch),
);

// Module Exports
export { getLocale };
